module.exports = __webpack_public_path__ + "img/intro-screen-bg-green.39d67223.png";